import * as get from 'lodash/get';

import { ColumnExtractor } from './column-extractor';

export class LodashExtractor implements ColumnExtractor {
	constructor(public readonly expression: string, public readonly defaultValue?: number | string) { }
	public extractor(): (storeData: any) => number | string {
		return (storeData: any) => get(storeData, this.expression, this.defaultValue);
	}

	public getDataPointPath(): string {
		return this.expression;
	}
}
